import { TemplateConfig } from '../types';

export const secretLoveConfig: TemplateConfig = {
  id: 'secret-love',
  name: '暗恋牌阵',
  description: '分析暗恋情况，了解对方想法和表白时机',
  cardCount: 6,
  
  fieldDefaults: {
    title: '暗恋牌阵',
    customerQuestion: '有喜欢的人，不知道如何行动，想知道对方的想法、想知道近期是否合适表白。',
    cardPlaceholders: [
      '请输入第 1 行第 1 张牌',
      '请输入第 1 行第 2 张牌',
      '请输入第 2 行第 1 张牌',
      '请输入第 2 行第 2 张牌',
      '请输入第 3 行第 1 张牌',
      '请输入第 3 行第 2 张牌'
    ],
    cardInfos: [
      '对方对我的真实想法',
      '对方对我的第一印象',
      '我和对方在一起的可能性',
      '近期是否要采取行动',
      '我和对方的关系的最后结果',
      '指引及建议'
    ]
  },
  
  disabledFields: ['title', 'customerQuestion', 'cardCount', 'cardInfos'],
  
  generateOptions: {
    normal: true,
    thinking: true
  },
  
  ui: {
    color: '#eb2f96',
    backgroundColor: '#fff0f6',
    icon: '💕'
  }
};